import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { InsuranceCompaniesService } from '../_services/insurance-companies.service';
import { InsuranceCompany } from '../_types/insurance-company';

@Component({
    selector: 'app-insurance-companies-list',
    templateUrl: './insurance-companies-list.component.html',
    styleUrls: ['./insurance-companies-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class InsuranceCompanyListComponent implements OnInit {
  public insuranceCompanies: InsuranceCompany[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowDelete: boolean = false;


  constructor(
    private insuranceCompaniesService: InsuranceCompaniesService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private loginService: LoginService
  ) {
    this.allowDelete = this.loginService.hasPermission("INSURANCE_COMPANIES.DELETE");
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Compañías de seguros");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.insuranceCompaniesService.all(params));
    this.insuranceCompanies = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(insuranceCompany: any) {
    this.router.navigate(['insuranceCompanies/' + (insuranceCompany && Object.keys(insuranceCompany).length > 0 ? insuranceCompany.id : 0)]);
  }

  delete(insuranceCompany: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la compañía de seguros "+insuranceCompany.name+"?",
        header: "Eliminar compañía de seguros",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.insuranceCompaniesService.delete(insuranceCompany.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Compañía de seguros eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
